"use strict";

exports.__esModule = true;
exports["default"] = rtlTextAlign;

function rtlTextAlign(align, direction) {
  var rtl = direction === 'rtl';

  if (rtl && align === 'start' || !rtl && align === 'end') {
    return 'right';
  } else if (rtl && align === 'end' || align === 'start') {
    return 'left';
  } else {
    return align;
  }
}